import React, { useEffect, useState, useRef } from "react";
import Icd10Service from "../../../../services/Icd10Service";
import Icons from "../../../../components/UI/Icons";
import EmrConfigService from "../../../../services/EmrConfigService";
import FormInputs from "../../../../components/UI/FormInputs";
import { convertUnderScoreStrings } from "../../../../utils/commonUtils";
import EmrVisitsService from "../../../../services/EmrVisitsService";

const IcdDisplay = ({ bodyparts, onToggle, selectedCodes = [] ,visit_id,setSelecetedBodyParts,isrenderICD,setSelectedIcdCodes,Loader,Toast}) => {
  const [icdList, setIcdList] = useState([]);
  // const [selectedCodes, setSelectedCodes] = useState([]);
  const [searchTerm,setSearchTerm]= useState("")
  const isFirstRender = useRef(true);
 console.log("isrenderICD",isrenderICD);
  useEffect(()=>{    
    const delay = setTimeout(() => {
      fetchIcdList(bodyparts);
    }, 300); 
    return () => clearTimeout(delay);
  },[isrenderICD,searchTerm])

  useEffect(() => {
    icdList.forEach((item) => {
      const isManuallyChecked = selectedCodes.some((icd) => icd.code === item.code);
      const shouldBeAutoChecked = !!item.assessment_id && item.is_updated === true;
  
      if (!isManuallyChecked && shouldBeAutoChecked) {
        toggleCode(item.code, item.assessment_id, item.icd10_id,item.body_parts); // ✅ fix
      } 
    });
  }, [icdList]);
  
  

  const fetchIcdList = async (bodyparts) => {
    try {
      // const payload = { body_parts: bodyparts };
      console.log(bodyparts,"bodyparts");
      setSelectedIcdCodes([])
      Loader(true)
      const response = await EmrVisitsService.getAssessmentICD10DList(
        null,
        visit_id,
        {
          body_parts:bodyparts||"",
          search_query:searchTerm||""
        }
      );
      Loader(false)
     // console.log(response);
      const icdList = response?.data || [];
      const bodyPartsList=icdList.map(itm=>itm.body_parts);
      // console.log("bodyPartsList",bodyPartsList);
      const updatedBodyParts=new Set([...bodyparts,...bodyPartsList]);
      // console.log(updatedBodyParts,"updatedBodyParts");
            // console.log( typeof [...updatedBodyParts],"updatedBodyParts type of");

      setSelecetedBodyParts([...updatedBodyParts]);
      setIcdList(icdList);
    } catch (err) {
      Loader(false)
      Toast.error("Something went wrong.");
      console.error("Error fetching ICD-10 list", err);
    }
  };

  const toggleCode = (code, assessment_id, icd10_id,body_parts) => {
    const isChecked = selectedCodes.some((icd) => icd.code === code);
    onToggle(code, !isChecked, assessment_id, icd10_id,body_parts);
  };
  

  
  
  const selectedCodeString = selectedCodes.join(",");

  return (
    <div className="col-3">
      <div className="sh_emrcardrow">
        <div
          className="sh_cardBox sh_emrfieldcardbox mb-1"
          style={{ height: "calc(100vh - 490px)" }}
        >
          <div className="sh_emrcardHead sh_cardHeader py-2 px-2 position-relative">
            <div class="d-flex  align-items-center w-100">
              {/* <div class="d-flex  justify-content-start w-100">
             
               
                  <Icons type={"blue"} fontSize={"23px"} />
               
                <span
                  className={`sh_emr_roundbadge chart`}
                  title="Chart"
                  // onClick={async () => {
                  //   if (fields.length === 0) return;
                  //   const allSelectedNow =
                  //     fields.length > 0 &&
                  //     fields.every((f) =>
                  //       selectedFormIds.includes(f.emr_form_id)
                  //     );

                  //   const formIdsToProcess = fields
                  //     .filter(
                  //       (f) =>
                  //         allSelectedNow
                  //           ? selectedFormIds.includes(f.emr_form_id) // being removed
                  //           : !selectedFormIds.includes(f.emr_form_id) // being added
                  //     )
                  //     .map((f) => f.emr_form_id);

                  //   const combinedIds = formIdsToProcess.join(",");

                  //   // 🔁 Call API with correct flag
                  //   await handleNormalSubmit(
                  //     combinedIds,
                  //     0,
                  //     allSelectedNow ? 1 : 0
                  //   );

                  //   if (allSelectedNow) {
                  //     // Deselect all charts
                  //     setSelectedFormIds((prev) =>
                  //       prev.filter(
                  //         (id) => !fields.some((f) => f.emr_form_id === id)
                  //       )
                  //     );
                  //   } else {
                  //     // Select all charts
                  //     const newIds = fields.map((f) => f.emr_form_id);
                  //     setSelectedFormIds((prev) => [
                  //       ...new Set([...prev, ...newIds]),
                  //     ]);

                  //     // Uncheck all N
                  //     setNormalCheckedFormIds((prev) =>
                  //       prev.filter(
                  //         (id) => !fields.some((f) => f.emr_form_id === id)
                  //       )
                  //     );

                  //     fields.forEach(({ emr_form_id, name }) => {
                  //       if (!selectedFormIds.includes(emr_form_id)) {
                  //         handleCheckboxChange(emr_form_id, true);
                  //         if (fieldSearched) {
                  //           handleSearch(emr_form_id, name, false);
                  //           SetFieldSearched(false);
                  //         }
                  //       }
                  //     });
                  //   }
                  // }}
                  role="checkbox"
                  // aria-checked={allSelected}
                  tabIndex={0}
                >
                  C
                </span>
              </div> */}
              <h6 class="mb-0 text-sm  font-weight-bold sh_emrchartfieldheader">
                Charts
              </h6>
              <div class="d-flex align-items-center w-100 justify-content-center"></div>
            </div>

            <div className=" emrinlinesearchbox ">
              {/* <Buttons
             className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
             clickHandler={handleSearch}
             iconType={"SearchDarkBg"}
             /> */}
              <button
                type="button"
                className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
                // onClick={handleSearch}
              >
                <Icons type={"SearchDarkBg"} />
              </button>
              <FormInputs
                type="text"
                name="text"
                className="emrinlinesearchinput"
                placeholder="search ICD..."
                value={searchTerm}
                changeHandler={(val) => {
                  setSearchTerm(val);
                }}
              />
            </div>
          </div>


          <div className="sh_emrcardBody sh_cardBody py-1">
            {icdList.length > 0 ? (
              icdList.map((item) => {
                const isChecked = selectedCodes.some((icd) => icd.code === item.code)
               
                const isAlreadyCheck =item.assessment_id || item.is_updated === true;
              
              
                return (
    
                    <div className="row" key={item.icd10_id}>
                    <div className="w-25 px-1">
                      <div className="d-flex justify-content-start w-100">
                      <span
                            style={{
                              paddingTop: "2px",
                              display: "inline-block",
                            }}
                          >
                            <Icons type={"blue"} fontSize={"23px"} />
                          </span>
                      <span
                       className={`sh_emr_roundbadge ${
                        isAlreadyCheck
                          ? "normal"
                          : isChecked
                          ? "chart"
                          : "inactive"
                      }`}
                        title="Chart"
                        role="checkbox"
                        aria-checked={isChecked}
                        tabIndex={0}
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleCode(item.code, item.assessment_id, item.icd10_id,item.body_parts)}
                      >
                        C
                      </span>

                    </div>
                  </div>
                  <div className="w-75  pl-3 d-flex align-items-center">
                        <label
                       className="formlabel text-wrap-anywhere mb-0"
                          htmlFor={item.icd10_id}
                        >
                          {/* {item.code} -  {convertUnderScoreStrings(item.body_parts)} */}
                          {item.code} - {convertUnderScoreStrings(item.body_parts)}
                        </label>
                      </div>
                  </div>
                );
              })
            ) : (
              <p className="text-sm text-muted">No ICD-10 codes found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IcdDisplay;
